<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Administrer tilvalg</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <div class="dragdrop-container">
    <h4>Alle tilvalg</h4>
    <div
      cdkDropList
      cdkDropListSortingDisabled
      #leftSide="cdkDropList"
      [cdkDropListData]="tilvalg"
      [cdkDropListConnectedTo]="[rightSide]"
      class="dragdrop-list"
      (cdkDropListDropped)="drop($event)"
      >
      @for (t of tilvalg; track t) {
        <div class="dragdrop-element" cdkDrag [matTooltip]="'Tilføj tilvalg til abonnement'">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <p>{{ t?.tilvalgType }}</p>
              </mat-panel-title>
              <mat-panel-description>
                <p>{{ t?.name }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p>Varenr: {{ t?.okKundeVarenr }}</p>
          </mat-expansion-panel>
        </div>
      }
    </div>
  </div>
  <div class="dragdrop-container">
    <h4>Tilknyttede tilvalg</h4>
    <div
      cdkDropList
      #rightSide="cdkDropList"
      cdkDropListSortingDisabled
      [cdkDropListData]="selectedTilvalg"
      [cdkDropListConnectedTo]="[leftSide]"
      class="dragdrop-list"
      (cdkDropListDropped)="drop($event)"
      >
      @for (t of selectedTilvalg; track t) {
        <div class="dragdrop-element" cdkDrag [matTooltip]="'Fjern tilvalg fra abonnement'">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ t?.tilvalgType }}
              </mat-panel-title>
              <mat-panel-description>
                {{ t?.name }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p>Varenr: {{ t?.okKundeVarenr }}</p>
          </mat-expansion-panel>
        </div>
      }
    </div>
  </div>

  <div mat-dialog-actions>
    <button mat-dialog-close mat-raised-button>Fortryd</button>
    <button [disabled]="!hasChanges" mat-raised-button color="primary" (click)="submit()">Gem</button>
  </div>
</div>
